import { render } from "./LabelText.vue?vue&type=template&id=26ff2c0e&scoped=true&ts=true"
import script from "./LabelText.vue?vue&type=script&lang=ts"
export * from "./LabelText.vue?vue&type=script&lang=ts"

import "./LabelText.vue?vue&type=style&index=0&id=26ff2c0e&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26ff2c0e"]])

export default __exports__